import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { api } from "../api";

/** Local stand-in for Okta. Phase 3 replaces the picker with the OIDC redirect. */
export function SignInPage() {
  const qc = useQueryClient();
  const methods = useQuery({ queryKey: ["auth-methods"], queryFn: api.authMethods });
  const users = useQuery({ queryKey: ["dev-users"], queryFn: api.devUsers, retry: false, enabled: !!methods.data?.dev });
  const failure = new URLSearchParams(window.location.search).get("signin");
  const returnTo = window.location.pathname === "/" ? "/" : window.location.pathname + window.location.search;
  const [error, setError] = useState<string | null>(null);

  async function signIn(userId: string) {
    setError(null);
    try {
      await api.devSignIn(userId);
      await qc.invalidateQueries({ queryKey: ["me"] });
    } catch (e) {
      setError((e as Error).message);
    }
  }

  return (
    <div className="center-screen center-screen--scroll">
      <forge-card style={{ width: "min(480px, 92vw)" }}>
        <div className="stack gap-medium">
          <div className="row gap-small">
            <forge-icon name="vpn_key" />
            <h1 className="forge-typography--heading4 card-title">AI Gateway Access</h1>
          </div>
          <p className="forge-typography--body2 card-title">
            Get a key for Claude Code, Codex, opencode or Claude Desktop, and see what you are using.
          </p>
          {failure && (
            <forge-inline-message theme="error">
              <forge-icon slot="icon" name="error" />
              <div slot="title">{failure === "unknown-user" ? "No gateway account for you in this snapshot" : "Sign-in did not complete"}</div>
              <span>{failure === "unknown-user" ? "The snapshot is read-only, so it cannot create your account." : "Please try again. If it keeps failing, post in the AI Gateway Early Adopters channel in Teams."}</span>
            </forge-inline-message>
          )}
          <forge-button variant="raised" disabled={!methods.data?.oidc || undefined}
            onClick={() => { window.location.href = `/auth/login?returnTo=${encodeURIComponent(returnTo)}`; }}>
            Sign in with Okta
          </forge-button>
          {methods.data?.dev && (
            <forge-inline-message theme="info">
              <forge-icon slot="icon" name="info" />
              <div slot="title">Development sign-in</div>
              <span>This server also lets you pick who to be. It is off in the production image.</span>
            </forge-inline-message>
          )}
          {methods.data?.dev && users.isPending && <forge-skeleton />}
          {users.data && (
            <forge-list>
              {users.data.map((u) => (
                <forge-list-item key={u.userId} two-line>
                  <forge-icon slot="start" name={u.role === "proxy_admin" ? "admin_panel_settings" : "people"} />
                  <button type="button" className="list-button" onClick={() => signIn(u.userId)}>
                    {u.email ?? u.userId}
                  </button>
                  <span slot="secondary-text">{u.role === "proxy_admin" ? "Administrator" : "Employee"}</span>
                </forge-list-item>
              ))}
            </forge-list>
          )}
          {error && <forge-inline-message theme="error"><div slot="title">{error}</div></forge-inline-message>}
        </div>
      </forge-card>
    </div>
  );
}
